module.exports = __webpack_public_path__ + "static/person-1-390173f741d7588eab393f647a9c2e53.png";